export default function JobPencilOnlyIco({ size }) {
  return (
    <svg
      width={size || "14"}
      height={size || "14"}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9524 4.69233L9.40745 7.42904L9.96727 8.03192L9.44797 8.59514L5.56235 4.41062L6.08534 3.85138L6.64516 4.45426L9.18639 1.71349C9.55285 1.31735 10.051 1.09425 10.5703 1.09375C11.0896 1.09325 11.5877 1.31537 11.9546 1.71101C12.322 2.10616 12.5282 2.6426 12.5278 3.20185C12.5273 3.7611 12.3202 4.29755 11.9523 4.69218L11.9524 4.69233ZM7.24548 8.6348H3.80183L6.04476 6.22327L5.52546 5.66005L2.46118 8.96004C1.97917 9.48013 1.78396 10.2332 1.94556 10.9471C1.89215 11.1227 1.82954 11.2947 1.75772 11.4628C1.52568 12.0339 1.32681 12.5257 1.61776 12.8431C1.7172 12.9467 1.85118 13.0027 1.98974 12.9977C2.30648 12.9571 2.61402 12.8535 2.89577 12.6923C3.05321 12.6155 3.21435 12.5481 3.37825 12.4901C4.04119 12.6661 4.74138 12.4553 5.22342 11.9348L8.28769 8.63478L7.7647 8.07553L7.24548 8.6348Z"
        fill="#475E75"
      />
      <path
        d="M5.50622 6.06641L7.99934 8.55953L6.00484 10.554L3.51172 8.55953L5.50622 6.06641Z"
        fill="#475E75"
        stroke="#475E75"
        stroke-width="0.498625"
      />
    </svg>
  );
}
